'use strict';

module.exports = require('./matrix');
module.exports.Decompositions = module.exports.DC = require('./decompositions');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-optimize-lorentzian/~/ml-matrix/src/index.js
 ** module id = 27
 ** module chunks = 0
 **/